/* This file is autogenerated, see readme.md for instructions */
import OfflineFillSvgIcon from '@bloomreach/banana-theme/icons/offline-fill.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const OfflineFillIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <OfflineFillSvgIcon />
    </Icon>
  );
});

OfflineFillIcon.displayName = 'OfflineFillIcon';

export default OfflineFillIcon;
